/* eslint quote-props: ["error", "as-needed"] */

import { toRem } from 'helpers/theme'

const style = ({ theme }) => ({
    '& .highlightedPartner': {
        display: 'grid',
        gridTemplateColumns: '1fr',

        '& .title': {
            fontSize: toRem(26),

            [theme.breakpoints.up('md')]: {
                fontSize: toRem(50)
            }
        },

        '& .subtitle': {
            fontSize: toRem(16),

            [theme.breakpoints.up('md')]: {
                fontSize: toRem(18)
            }
        },

        '&__image': {
            marginBottom: toRem(15),

            [theme.breakpoints.up('md')]: {
                order: 2,
                marginBottom: 0
            }
        },

        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '1fr 1fr',
            justifyContent: 'space-between',
            alignItems: 'row-reverse',
            gridGap: toRem(45)
        }
    }
})

export default style
